import React from 'react'
import Header from '../component/header'
import BannerImg from '../image/education.png'
import Banner from '../component/Banner'
import Footer from '../component/Footer'

function PrivacyPolicy() {
  return (
<>
    <Header />
    <Banner
            backgroundImage={BannerImg}
            heading="Privacy Policy"
            paragraph="Lightweave Beacon Legacy believes that every artist deserves guidance, not from gatekeepers, but from mentors, peers, and shared learning. Our education programs provide structured study, tutorials, critique insights, and learning materials designed to elevate the craft across architecture, photography, sculpture, and technical design. Whether emerging or experienced, this is where creative skill matures into mastery."
            minHeight="100vh"
            padding="80px 0"
            bton="Members please sign-in"
          />
<div className="max-w-4xl mx-auto py-16 px-6 text-gray-800 leading-relaxed font-outfit">

  <h1 className="text-4xl font-cinzel mb-6">Privacy Policy</h1>
  <p className="mb-4">Last updated: January 2025</p>

  <p className="mb-6">
    This Privacy Policy explains how <strong>[Organization Name]</strong> (“we,” “our,” or “us”) 
    collects, uses, protects, and shares your personal information when you visit or use 
    <strong> [Website URL]</strong> (the “Site”) and any related services, memberships,
    submissions, or digital tools we provide.
  </p>

  <h2 className="text-2xl font-cinzel mt-10 mb-3">1. Information We Collect</h2>

  <h3 className="text-xl font-semibold mt-4">A. Information You Provide Directly</h3>
  <ul className="list-disc ml-6 mt-2">
    <li>Name and contact details (email, phone, address)</li>
    <li>Account login information</li>
    <li>Membership details and subscription information</li>
    <li>Artwork submissions, uploads, and portfolio content</li>
    <li>Billing information (processed securely by third-party payment processors)</li>
    <li>Messages, support inquiries, and feedback</li>
  </ul>

  <h3 className="text-xl font-semibold mt-6">B. Information Collected Automatically</h3>
  <ul className="list-disc ml-6 mt-2">
    <li>IP address and device information</li>
    <li>Browser type and settings</li>
    <li>Pages visited and time spent on the Site</li>
    <li>Cookies and tracking technologies (analytics, performance, preferences)</li>
  </ul>

  <h2 className="text-2xl font-cinzel mt-10 mb-3">2. How We Use Your Information</h2>

  <ul className="list-disc ml-6 mt-2">
    <li>To create, manage, and secure your account</li>
    <li>To operate membership programs and gallery submissions</li>
    <li>To process payments and subscription renewals</li>
    <li>To showcase artworks in galleries (with your permission)</li>
    <li>To improve user experience and personalize content</li>
    <li>To provide customer support</li>
    <li>To communicate updates, newsletters, and curated opportunities</li>
    <li>To comply with legal and regulatory requirements</li>
  </ul>

  <h2 className="text-2xl font-cinzel mt-10 mb-3">3. Sharing Your Information</h2>

  <p className="mt-2">
    We do <strong>not</strong> sell or trade your personal information. We may share your information with:
  </p>
  <ul className="list-disc ml-6 mt-2">
    <li>Trusted service providers (hosting, analytics, payment processors)</li>
    <li>Legal authorities when required by law</li>
    <li>Internal teams managing content, galleries, or memberships</li>
  </ul>

  <h2 className="text-2xl font-cinzel mt-10 mb-3">4. Cookies & Tracking Technologies</h2>

  <p className="mt-2">
    We use cookies to remember your preferences, improve performance, and understand how visitors navigate
    the Site. You may disable cookies in your browser settings, but some features may stop working correctly.
  </p>

  <h2 className="text-2xl font-cinzel mt-10 mb-3">5. How We Protect Your Information</h2>

  <ul className="list-disc ml-6 mt-2">
    <li>Secure SSL encryption</li>
    <li>Restricted access to personal data</li>
    <li>Encrypted payment processing through third-party services</li>
    <li>Regular security audits and system checks</li>
  </ul>

  <h2 className="text-2xl font-cinzel mt-10 mb-3">6. Your Rights & Choices</h2>

  <ul className="list-disc ml-6 mt-2">
    <li>Access the personal information we store</li>
    <li>Request corrections or updates</li>
    <li>Delete your account or request removal of your data</li>
    <li>Opt-out of marketing emails</li>
    <li>Control cookie and tracking settings</li>
  </ul>

  <h2 className="text-2xl font-cinzel mt-10 mb-3">7. Data Retention</h2>

  <p className="mt-2">
    We retain personal information only as long as necessary for membership services, compliance obligations,
    and legitimate business purposes.
  </p>

  <h2 className="text-2xl font-cinzel mt-10 mb-3">8. Children’s Privacy</h2>

  <p className="mt-2">
    Our services are not intended for children under 13. We do not knowingly collect personal data from
    children. If you believe a child has provided information, please contact us immediately.
  </p>

  <h2 className="text-2xl font-cinzel mt-10 mb-3">9. Updates to This Policy</h2>

  <p className="mt-2">
    We may update this Privacy Policy from time to time. All changes will be posted on this page with a new
    “Last Updated” date.
  </p>

  <h2 className="text-2xl font-cinzel mt-10 mb-3">10. Contact Us</h2>

  <p className="mt-2">
    If you have any questions or concerns about this Privacy Policy or wish to exercise your rights, please
    contact us at:<br />
    <strong>Email:</strong> support@[yourorganization].com<br />
    <strong>Website:</strong> [Website URL]
  </p>

</div>
<Footer/>

</>
  )
}

export default PrivacyPolicy